import CONSTS from '../constants'
import Component from './component'

export class Header extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    // classes extensions
    Object.assign(this.classes, {
      showLoginLink: '.js-header-show-login',
      menuButton: '.js-header-menu',
    })

    this.bindShowLogin()
    this.bindMenuButton()
  }

  bindShowLogin() {
    this.$showLoginLink = this.$ctx.find(this.classes.showLoginLink)

    if (this.$showLoginLink.length > 0) {
      this.$showLoginLink.on('click', (event) => {
        event.preventDefault()

        this.ev.emit(CONSTS.EVENTS.SHOW_LOGIN)
      })
    }
  }

  bindMenuButton() {
    this.$menuButton = this.$ctx.find(this.classes.menuButton)

    this.$menuButton.on('click', (event) => {
      event.preventDefault()

      this.ev.emit(CONSTS.EVENTS.OPEN_SIDE_NAVI)
    })
  }

  onResize() {
    // noop
  }
}
